// Tour / highlight stacking — must sit above rail popovers (9200 per
// `railPopoverPanelStyle` in useRailPopover.ts) so bucket-switch steps
// can highlight items inside the workspace picker.

/** Ring outline around a highlighted control during tours. */
export const FIREFLY_TOUR_HIGHLIGHT_RING_Z = 9250;

/** Portaled firefly bug during tour travel or target highlight. */
export const FIREFLY_TOUR_BUG_Z = 9255;

/** Bottom step callout during guided tours. */
export const FIREFLY_TOUR_CALLOUT_Z = 9260;

/** Default portaled firefly (dock tab, dev lab) — below rail popovers. */
export const FIREFLY_DEFAULT_PORTAL_Z = 9100;
